module.exports = __webpack_public_path__ + "media/1.8fd96f1a.mp4";